import { useMutation } from 'urql';

export default useMutation;
